import { calculateAspects } from '../aspects.js';
import { clearElement, enrichPlanetList, htmlElement } from '../utils.js';

export function renderAspectMatrix(container, snapshot) {
  clearElement(container);
  const natal = enrichPlanetList(snapshot?.natal?.planets || []).filter(isAspectBody);
  const transit = enrichPlanetList(snapshot?.transit?.planets || []).filter(isAspectBody);
  const aspects = Array.isArray(snapshot?.aspects)
    ? snapshot.aspects
    : calculateAspects({ source: transit, target: natal });
  const lookup = new Map(aspects.map((aspect) => [`${aspect.from.id}:${aspect.to.id}`, aspect]));

  const wrapper = htmlElement('div', { className: 'aspect-matrix-wrapper' });
  const table = htmlElement('table', { className: 'aat-data-table aspect-matrix' });
  const head = htmlElement('thead');
  const headRow = htmlElement('tr');
  headRow.append(htmlElement('th', { text: 'Transit ↓ / Natal →' }));
  natal.forEach((planet) => headRow.append(htmlElement('th', { text: planet.short, title: planet.name })));
  head.append(headRow);
  const body = htmlElement('tbody');
  transit.forEach((from) => {
    const row = htmlElement('tr');
    row.append(htmlElement('th', { text: from.short, title: from.name }));
    natal.forEach((to) => {
      const aspect = lookup.get(`${from.id}:${to.id}`);
      if (!aspect) {
        row.append(htmlElement('td', { className: 'aspect-empty', text: '·' }));
        return;
      }
      const symbol = aspectSymbol(aspect.type);
      row.append(htmlElement('td', {
        className: `aspect-cell aspect-${aspect.type}`,
        text: `${symbol} ${Number(aspect.orb).toFixed(1)}°`,
        title: `${from.name} ${aspect.label} ${to.name}; orb ${Number(aspect.orb).toFixed(2)}°${aspect.applying === null ? '' : aspect.applying ? '; applying' : '; separating'}`,
      }));
    });
    body.append(row);
  });
  table.append(head, body);
  wrapper.append(table);

  const list = htmlElement('div', { className: 'aspect-list' });
  list.append(htmlElement('h3', { text: 'Exact and near-exact aspects' }));
  const listTable = htmlElement('table', { className: 'aat-data-table compact' });
  const listHead = htmlElement('thead');
  listHead.append(htmlElement('tr', {}, [
    htmlElement('th', { text: 'Transit' }),
    htmlElement('th', { text: 'Aspect' }),
    htmlElement('th', { text: 'Natal' }),
    htmlElement('th', { text: 'Orb' }),
    htmlElement('th', { text: 'Motion' }),
  ]));
  const listBody = htmlElement('tbody');
  aspects.forEach((aspect) => {
    listBody.append(htmlElement('tr', {}, [
      htmlElement('td', { text: aspect.from.name }),
      htmlElement('td', { text: aspect.label }),
      htmlElement('td', { text: aspect.to.name }),
      htmlElement('td', { text: `${Number(aspect.orb).toFixed(2)}°` }),
      htmlElement('td', { text: aspect.applying === null ? '—' : aspect.applying ? 'Applying' : 'Separating' }),
    ]));
  });
  listTable.append(listHead, listBody);
  list.append(listTable);
  container.append(wrapper, list);
  return { table, listTable };
}

function isAspectBody(planet) {
  return !['ascendant', 'rahu', 'ketu'].includes(planet.id);
}

function aspectSymbol(type) {
  return {
    conjunction: '☌',
    sextile: '⚹',
    square: '□',
    trine: '△',
    opposition: '☍',
  }[type] || '•';
}
